/**
 * Transforme le nom de famile donné en paramètre
 * pour un format officiel, donc tout en majuscule
 *
 * @param name Le nom de famille
 */
export const toOfficialLastname = (lastname: string) => lastname.toUpperCase();

/**
 * Transforme le prénom donné en paramètre
 * pour un format officiel, donc la première lettre en majuscule non accentuée
 * et le reste en minuscule
 *
 * @param firstname Le prénom
 */
export const toOfficialFirstname = (firstname: string) =>
  firstname.charAt(0).toUpperCase() + firstname.slice(1).toLowerCase();
